import LRUCache from "lru-cache";
import db from "./db";
const withCache = (cache, lookupFunction)=>{
    return async (input)=>{
        const cachedResult = cache.get(input);
        if (cachedResult) {
            return cachedResult;
        }
        const resolvedResult = await lookupFunction(input);
        if (resolvedResult) {
            cache.set(input, resolvedResult);
        }
        return resolvedResult;
    };
};
export const applicationIdCache = new LRUCache(50);
export const applicationIdToOrganizationIdCache = new LRUCache({
    max: 50,
    maxAge: 1000 * 60 * 5
});
const applicationAuthnTokenToApplicationIdCache = new LRUCache({
    max: 50,
    maxAge: 1000 * 60 * 5
});
/**
 * Fetch the application & scopes from
 */ export const applicationIdFromAuthToken = withCache(applicationAuthnTokenToApplicationIdCache, async (authnToken)=>{
    const applicationAuthToken = await db.applicationAuthenticationToken.findFirst({
        where: {
            token: authnToken
        },
        select: {
            applicationId: true,
            scopes: true
        }
    });
    return applicationAuthToken;
});
